import { bubEvents } from 'shared/events/bub_events';

$(document).ready(() => {
  $('.track-link').click((e) => {
    // use 'currentTarget' to properly capture the link parent of a clicked image
    bubEvents.track(e.currentTarget.dataset.category, e.currentTarget.dataset.action, {
      label: e.currentTarget.dataset.label,
      value: e.currentTarget.dataset.value,
    });
  });

  // tracks the display of an element upon pageload via data attributes
  $('.track-impression').each((index, elem) => {
    bubEvents.track(elem.dataset.category, elem.dataset.action, {
      label: elem.dataset.label,
      value: elem.dataset.value,
    });
  });
});
